import { mapToList } from "./utils";

export const EnumSettleStatus = {
  A: 0, // 待打款
  B: 1, // 待领取
  C: 2, // 领取超时返还
  D: 3, // 打款成功
  E: 4, // 关单未结算
  F: 5, // 撤回转账
};

export const SettleStatusToTextMap = new Map([
  [EnumSettleStatus.A, "待打款"],
  [EnumSettleStatus.B, "待领取"],
  [EnumSettleStatus.C, "领取超时返还"],
  [EnumSettleStatus.D, "打款成功"],
  [EnumSettleStatus.E, "关单未结算"],
  [EnumSettleStatus.F, "撤回转账"],
]);

export const SettleStatusToStyleMap = new Map([
  [EnumSettleStatus.A, ""],
  [EnumSettleStatus.B, ""],
  [EnumSettleStatus.C, "color:red"],
  [EnumSettleStatus.D, "color:green"],
  [EnumSettleStatus.E, "color:red"],
  [EnumSettleStatus.F, "color:red"],
]);

export const SettleStatusList = mapToList(SettleStatusToTextMap);

// 获取代扣渠道标签颜色
export function getSettleStatusStyle(status) {
  return SettleStatusToStyleMap.get(status) || "";
}

export const EnumSettleType = {
  A: 1, // 线下打款
  B: 2, // 吱口令结算
};

export const SettleTypeToTextMap = new Map([
  [EnumSettleType.A, "线下打款"],
  [EnumSettleType.B, "吱口令结算"],
]);

export const SettleTypeList = mapToList(SettleTypeToTextMap);
